/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { ServiceType } from 'shared';

import { PlanCompute } from '../../types/common/PlanCompute';
import { PlanStorage } from '../../types/common/PlanStorage';
import { PlanActions, PlanActionTypes } from './types';

export const getPlanByProduct = (serviceType: ServiceType): PlanActionTypes => ({
  type: PlanActions.GET_PLAN_WATCHER,
  payload: { serviceType },
});

export const fetchPlanActions = {
  request: (): PlanActionTypes => ({
    type: PlanActions.GET_PLAN_REQUEST,
  }),
  success: ({ compute, storage }: { compute: PlanCompute[]; storage: PlanStorage[] }): PlanActionTypes => ({
    type: PlanActions.GET_PLAN_SUCCESS,
    payload: { compute, storage },
  }),
  error: (errorMessage?: string): PlanActionTypes => ({
    type: PlanActions.GET_PLAN_FAILURE,
    payload: { errorMessage },
  }),
};
